<template>
  <div>
    <Navbar :toReset="(url, stay, noTab) => this.reset(url, stay, noTab)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar
          active="Rawat Inap"
          :toReset="(url, stay, noTab) => this.reset(url, stay, noTab)"
        />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid" v-if="loaded">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop">
            <div class="col-md-12">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
          </div>
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div class="row">
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">
                hasil pemeriksaan dokter
              </h5>
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <FormRow
                v-for="row in rightForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-10" style="position: relative">
              <hr />
              <div class="d-flex flex-between mt-4 mb-3">
                <h5 class="mb-2">Diagnosa</h5>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-12">
                    <div class="input-group">
                      <input
                        type="text"
                        :class="
                          'form-control form-control-lg pl-5 with-icon-left without-label ' +
                            (isError ? 'error' : '')
                        "
                        placeholder="Cari kode atau nama klasifikasi medis"
                        @input="
                          (e) => {
                            a_medical = false;
                            s_medical = e.target.value;
                            updateForm();
                          }
                        "
                        :value="s_medical"
                        v-on:keyup.enter="() => search('medical')"
                      />
                      <i
                        class="material-symbols-outlined"
                        style="margin-top: -0.25rem"
                        >search</i
                      >
                      <div class="input-group-append">
                        <button
                          class="btn btn-secondary btn-with-icon-left"
                          @click="() => search('medical')"
                        >
                          <i class="material-symbols-outlined">search</i>
                          CARI
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <SearchResultMedical
                @addItem="(item) => addItem(item, 'medical')"
                v-if="s_medical && a_medical"
                :loading="l_medical"
                :data="r_medical"
              />
              <table
                class="responsive"
                v-if="medical.filter((item) => !item.deleted).length"
              >
                <thead>
                  <th>KODE</th>
                  <th>KLASIFIKASI MEDIS</th>
                  <th>DESKRIPSI</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr
                    v-for="item in medical.filter((item) => !item.deleted)"
                    v-bind:key="item.id + Math.random(1024)"
                  >
                    <td>
                      {{
                        item.tipe +
                          " " +
                          item.kode +
                          (item.subkode ? `.${item.subkode}` : "")
                      }}
                    </td>
                    <td>{{ item.desc_short }}</td>
                    <td>{{ item.desc_long }}</td>
                    <td>
                      <button
                        class="btn btn-icon btn-danger btn-sm"
                        @click="() => deleteItem('medical', item.id)"
                        v-if="item.status != 'DIBATALKAN'"
                      >
                        <i class="material-symbols-outlined">delete</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Data Pemeriksaan
                </button>
                <!-- <router-link
                  class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                  to="/ralan"
                  >Batalkan</router-link
                > -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => reset(`/ranap/detail/${$route.params.id}`)"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
        <div class="container-fluid" v-else>
          <Loading />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import SearchResultMedical from "@/components/SearchResultMedical.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
// import DetailRight from '@/components/DetailRight.vue'
import { setPatientIntro, convertSize, resetForms } from "@/data/helper.js";
import Loading from "@/components/Loading.vue";
// import { HTTP } from "@/config.js";
import {
  data,
  leftForm,
  rightForm,
  today,
  time,
} from "@/data/RanapFormDokter.js";

export default {
  name: "RanapFormDokter",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    Alert,
    SearchResultMedical,
    Loading,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      loaded: true,
      leftForm: leftForm,
      rightForm: rightForm,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      formSet: {
        id_dokter: "",
        tgl_periksa: today,
        jam_periksa: time,
        fisik: null,
        dx_utama: "",
        dx_sekunder: "",
        medis: "",
        soap: "",
      },
      metodeBayar: ["Umum", "BPJS", "Asuransi Lain"],
      saveSuccess: false,
      saveFailed: false,
      s_medical: "",
      r_medical: [],
      medical: [],
      a_medical: false,
      l_medical: false,
      isError: false,
    };
  },
  methods: {
    reset(url, stay, noTab) {
      // if (this.validated) {
      console.log("[---noTab");
      console.log(noTab);
      console.log("]---noTab");

      resetForms(
        this.formSet,
        [this.leftForm, this.rightForm],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;

          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          that.$router.push(`/ralan/detail/${that.$route.params.id}`);
        }, 1000);
      }
    },

    updateForm: function() {
      let self = this;
      let forms = [this.leftForm, this.rightForm].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              (self.formSet[column.name] &&
                self.formSet[column.name] != null &&
                self.formSet[column.name] != "null") ||
              self.formSet[column.name] == 0
            ) {
              if (["file", "image"].indexOf(column.type) > -1) {
                // column.value = '';
                self.updateImage(self.formSet[column.name], column);
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.leftForm = forms[0];
      this.rightForm = forms[1];
    },
    updateImage: async function(file, column) {
      let rowIndex = 1;
      column.value = await new Promise((resolve) => {
        var reader = new FileReader();
        reader.onload = (e) => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      ////console.log(column.value);
      ////console.log(this.leftForm);
      this.leftForm.splice(rowIndex, 1, this.leftForm[rowIndex]);
    },

    fetchMedical: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/pemeriksaan/medical?no_rawat=${this.formSet["no_rawat"]}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          self.medical = [];
          result.data.forEach((item) => {
            item.nama = item.periksamedical.nama;
            item.kode = item.periksamedical.kode;
            item.id_ralan_medical = item.id;
            item.id = item.periksamedical.id;
            self.medical = self.medical.concat(item);
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    search: async function(type) {
      //console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;

      let url;
      if (type == "medical") {
        url = "penyakit";
      } else {
        url = "tindakan";
      }
      try {
        let result = await this.$store.state.HTTP.get(
          // `${url}?per_page=10`
          `${url}?q=${this["s_" + type]}`
        );
        //console.log(result);
        if (result.status == "200") {
          this["r_" + type] = result.data;
          this["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          this["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      let found = false;
      this[type] = this[type].map((el) => {
        if (el.id == item.id) {
          el.deleted = false;
          found = true;
        }
        return el;
      });
      if (!found) {
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      //console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      //console.log(this[type]);
    },
    handleForm: async function() {
      this.loaded = false;
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let medical = this.medical.filter((item) => !item.deleted);
      let valid = this.validateForm() && medical.length;
      if (!medical.length) {
        alert("Diagnosa Wajib diisi!");
      }
      if (valid) {
        medical.forEach(async function(item, index) {
          //console.log(item.id);
          formData.append(`id_penyakit[${index}]`, item.id);
        });
        formData.append("id_ranap", this.$route.params.id);
        Object.keys(this.formSet).forEach(function(key) {
          formData.append(key, self.formSet[key]);
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "/ranap/pemeriksaan/dokter",
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              that.reset(`/ranap/detail/${that.$route.params.id}`);
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
      this.loaded = true;
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.leftForm, this.rightForm].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else {
              column.error = "";
            }
            if (column.type == "image") {
              if (self.formSet[column.name]) {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                  self.leftForm.map((item) => {
                    item.columns = item.columns.map((column) => {
                      return column;
                    });
                    return item;
                  });
                };
                // Cek ukuran file
                let size = self.formSet[column.name].size;
                //console.log(size);
                // Jika pada input ditentukan size maksimal, gunakan size pada input, jika tidak, gunakan default max size 10MB
                let maxSize = column.maxSize
                  ? parseInt(column.maxSize)
                  : 10485760;
                if (size > maxSize) {
                  valid = false;
                  column.error = `Melebihi ukuran maksimal file ${convertSize(
                    maxSize
                  )}`;
                }
                reader.readAsDataURL(self.formSet[column.name]);
              }
            } else {
              if (self.formSet[column.name]) {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.leftForm = forms[0];
      this.rightVital = forms[1];
      //console.log(self.formSet);
      return valid;
    },
    handlePopstate(event) {
      console.log("going in");
      this.reset(`/ranap/detail/${this.$route.params.id}`, false, true);
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          // this.rows = result.data;
          //console.log(this.rows);
          let dataPasien = result.data.pasien;
          //console.log(dataPasien);
          let ranap = result.data;
          //console.log(this.detailTop);

          let ralan = result.data.ralan;
          if (result.data.ralan.jen_periksa == "Kontrol Lanjutan") {
            this.rightForm[3].columns[0].type = "textarea";
          } else {
            this.rightForm[3].columns[0].type = "hidden";
          }
          this.idRalan = ralan.id;
          this.darurat = ralan.darurat;
          this.no_rawat = ranap.no_rawat;
          //console.log(ralan);
          this.detailTop = setPatientIntro(dataPasien);
          this.detailLeftTop = [
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "No. Registrasi   |    No. Rawat",
                  content: ralan.formatted_no_reg_rawat,
                  icon: "confirmation_number",
                  colwidth: 4,
                },
                {
                  label: "Kamar Inap",
                  content:
                    ranap.kamar_ranap.nama +
                    " | " +
                    ranap.kamar_ranap.formatted_kelas,
                  icon: "hotel",
                  colwidth: 4,
                },
                {
                  label: "Nomor Kasur",
                  content: ranap.kamar_ranap.formatted_no_kasur,
                  icon: "radio_button_checked",
                  colwidth: 4,
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "Waktu Check In",
                  content:
                    ranap.formatted_tgl_masuk + " " + ranap.formatted_jam_masuk,
                  icon: "apps",
                  colwidth: 4,
                },
                {
                  label: "Dokter yang Dituju",
                  content: ranap.dokter.formatted_nama,
                  icon: "person_pin",
                  colwidth: 4,
                },
                {
                  label: "Petugas Penanggung Jawab",
                  content: ranap.petugas.nama,
                  icon: "apps",
                  colwidth: 4,
                },
              ],
            },
          ];
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      console.log("Selalu Masuk Ke Sini");
      let that = vm;
      setTimeout(function() {
        var myElements = that.$el.querySelectorAll(".upload-image");
        console.log(myElements);
        // loop through each element and change its color
        for (var i = 0; i < myElements.length; i++) {
          myElements[i].style.backgroundImage = "";
          console.log(myElements[i]);
          console.log(myElements[i].style.backgroundImage);
        }
        // vm.blockLoading = false;
      }, 1000);

      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.toReset = (url, stay, noTab) => this.reset(url, stay, noTab);
    this.data.breadcrumb[1].link = `/ranap/detail/${this.$route.params.id}`;
    this.displayData();
  },
  created() {
    window.addEventListener("popstate", (event) => this.handlePopstate(event));
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("popstate", (event) =>
      this.handlePopstate(event)
    );
    next();
  },
};
</script>
